// extracted by mini-css-extract-plugin
module.exports = {"label":"label_label__JOY5u","icon":"label_icon__5ZMC0","loading":"label_loading__UbLp7","shine":"label_shine__VD5yZ"};